import { Link } from 'react-router-dom';
import { Image } from 'shared/components';
import { capitalCaseTransform } from 'capital-case';
import { routeConstants } from 'shared/constants';

const SuggestionItem = ({ extraText, text, image, onItemClick, query }) => {
  return (
    <li>
      <Link
        to={`${routeConstants.PRODUCTS.path}?${query}`}
        onClick={onItemClick}
        className="global_search_list"
      >
        <div className="searchimg">
          <Image src={image} alt="shoe" />
        </div>
        <div className="searchtext">
          {capitalCaseTransform(text)}
          <h6>in {extraText}</h6>
        </div>
      </Link>
    </li>
  );
};

export default SuggestionItem;
